import React, { useEffect, useState } from "react";
import "../../Styles/NewContactUs.css";
import { TextField } from "@mui/material";
import toast, { Toaster } from "react-hot-toast";
import { ContactUsAction } from "../../Action/user.action";
// import "./css/contactus.css";
import NewHeader from "../../directives/NewHeader";
import {
  Accordion,
  Button,
  Card,
  Col,
  Container,
  Form,
  Row,
} from "react-bootstrap";
import Footer from "../../directives/footer";
import { getFaqsAction } from "../../Action/user.action";
import ContactUsMetaTag from "../MetaTags/ContactUsMetaTag";
const NewContactUs = () => {
  const [activeKey, setActiveKey] = useState("0");
  const [faqs, setFaqsList] = useState([]);

  const toggleKey = (key) => {
    setActiveKey(activeKey === key ? null : key);
  };

  useEffect(() => {
    getFaqs();
  }, []);

  const getFaqs = async () => {
    let res = await getFaqsAction();
    if (res.success) {
      setFaqsList(res.data);
    } else {
      setFaqsList([]);
    }
  };

  const [userData, setuserData] = useState({
    name: "",
    email: "",
    text: "",
    subject: "",
    mobile_type: "website",
    mobile_detail: "none",
    phone: "",
  });
  const [validationError, setvalidationError] = useState({
    emailError: "",
    nameError: "",
    subjectError: "",
    mobileError: "",
    textError: "",
    userDataError: "",
    deviceError: "",
  });
  const [uuidName, setuuidName] = useState("");
  useEffect(() => {}, []);

  function validate() {
    let emailError = "";
    let nameError = "";
    let subjectError = "";
    let textError = "";
    let deviceError = "";
    let mobileError = "";

    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    const phoneRegex = /^\d{1,15}$/;

    // Name validation (disallow special characters and numbers)
    if (userData.name == "") {
      nameError = "Name is required.";
    }

    // Email validation
    if (userData.email == "") {
      emailError = "Email is required.";
    } else if (!emailRegex.test(userData.email)) {
      emailError = "Invalid email format.";
    }

    // Phone number validation (no more than 15 digits)
    if (userData.phone == "") {
      mobileError = "Phone Number is required.";
    } else if (!phoneRegex.test(userData.phone)) {
      mobileError = "Phone number must contain up to 15 digits.";
    }

    // Subject validation
    if (userData.subject == "") {
      subjectError = "Subject is required.";
    }

    // Text message validation
    if (userData.text == "") {
      textError = "Text message required";
    }

    // Mobile/Laptop details validation
    if (userData.mobile_detail == "") {
      deviceError = "Mobile/Laptop Details are required.";
    }

    if (
      emailError ||
      nameError ||
      subjectError ||
      textError ||
      deviceError ||
      mobileError
    ) {
      setvalidationError({
        emailError,
        nameError,
        mobileError,
        subjectError,
        textError,
        deviceError,
      });
      return false;
    } else {
      return true;
    }
  }

  const inputHandler = (e) => {
    const { name, value } = e.target;
    if (name === "mobile_type") {
      if (value.toLowerCase() === "android") {
        setuuidName(1);
      } else if (value.toLowerCase() === "ios") {
        setuuidName(2);
      } else {
        setuuidName("");
      }
    }
    setuserData((old) => {
      return { ...old, [name]: value };
    });
  };

  const contactusFunc = async () => {
    console.log(userData);
    const isValid = validate();
    if (!isValid) {
    } else {
      let res2 = await ContactUsAction(userData);
      if (res2.success) {
        toast.success(res2.msg);
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } else {
        toast.error(res2.msg);
      }
    }
  };

  return (
    <>
      <div className="position-fixed w-100 " style={{ zIndex: 999 }}>
        <NewHeader />
        <ContactUsMetaTag />

      </div>
      <div className="top-shelf-start"></div>
      <div className="position-relative">
        <div className="cp1"></div>
        <div className="cp2"></div>
        <div className="cp3"></div>
        <div className="cp4"></div>
        <div className="cp5"></div>

        <Container>
          <Row>
            <Col lg={6}>
              <div className="new-contact-us-form">
                <h4>
                  Get in <span className="new-contact-span">touch</span>{" "}
                </h4>
                <p>Our friendly team would love to hear from you.</p>
              </div>
              <Container className="py-2 text-white">
                <Form className="mx-auto" style={{ maxWidth: "720px" }}>
                  <Row className="mb-3">
                    <Col md={6} className="mb-md-0 mb-3">
                      <TextField
                        id="outlined-helperText"
                        label="Your Name"
                        type="text"
                        placeholder="Enter your name"
                        name="name"
                        onKeyPress={(e) => {
                          const regex = /^[a-zA-Z\s]*$/;
                          if (!regex.test(e.key)) {
                            e.preventDefault();
                          }
                        }}
                        onChange={inputHandler}
                        style={{ width: "100%" }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        autoComplete="off"
                      />
                      <span className="validationError">
                        {validationError.nameError}
                      </span>
                    </Col>
                    <Col md={6}>
                      <TextField
                        className=""
                        id="outlined-password-input"
                        label="Email Address"
                        type="email"
                        placeholder="Enter your email"
                        onChange={inputHandler}
                        name="email"
                        style={{ width: "100%" }}
                        autoComplete="off"
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                      <span className="validationError">
                        {validationError.emailError}
                      </span>
                    </Col>
                  </Row>

                  <Form.Group className="mb-4">
                    <Row>
                      <Col>
                        <TextField
                          id="outlined-password-input"
                          label="Subject"
                          type="text"
                          onChange={inputHandler}
                          placeholder="Enter subject..."
                          name="subject"
                          autoComplete="off"
                          style={{ width: "100%" }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                        <span className="validationError">
                          {validationError.subjectError}
                        </span>
                      </Col>
                    </Row>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Row>
                      <Col className="position-relative">
                        {/* Country Select */}
                        <div
                          style={{
                            position: "absolute",
                            top: "40%",
                            transform: "translateY(-50%)",
                            left: "10px",
                            zIndex: 2,
                          }}
                        >
                          <div className="custom-select-wrapper">
                            <Form.Select
                              className="gradient-border"
                              style={{ width: "70px" }}
                            >
                              <option>US</option>
                              <option>IN</option>
                              <option>UK</option>
                            </Form.Select>
                          </div>
                        </div>

                        {/* Phone Input */}
                        <TextField
                          id="outlined-password-input"
                          label="Enter Number"
                          type="number"
                          className="mb-3 cust-num"
                          onChange={inputHandler}
                          placeholder="Enter number..."
                          name="phone"
                          autoComplete="off"
                          style={{ width: "100%" }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                        <span className="validationError">
                          {validationError.mobileError}
                        </span>
                      </Col>
                    </Row>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <div>
                      <TextField
                        id="filled-textarea"
                        label="Your Message"
                        placeholder="Message"
                        type="text"
                        onChange={inputHandler}
                        name="text"
                        autoComplete="off"
                        multiline
                        rows={4}
                        className="message-tab-0"
                        style={{ width: "100%" }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                      <span className="validationError">
                        {validationError.textError}
                      </span>
                    </div>
                  </Form.Group>

                  {/* <Form.Group className="mb-4 d-flex">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="privacy"
                    />
                    <Form.Check
                      type="checkbox"
                      id="privacy"
                      className="ps-2"
                      label={
                        <>
                          You Agree to our friendly{" "}
                          <a
                            href="#"
                            className="text-decoration-underline text-light"
                          >
                            privacy policy
                          </a>
                        </>
                      }
                    />
                  </Form.Group> */}

                  <Button
                    type="submit"
                    onClick={contactusFunc}
                    className="w-100 new-custom-btn"
                  >
                    Send message
                  </Button>
                </Form>
              </Container>
            </Col>
            <Col lg={6}>
              <div>
                <img
                  src="assets\images\newdesign\newaboutus.png"
                  className="img-fluid"
                  alt=""
                />
              </div>
            </Col>
          </Row>
          <Container>
            <div className="new-contact-us-form2 text-center mt-5 mb-4">
              <h4>
                Frequently Asked{" "}
                <span className="new-contact-span2">Questions</span>{" "}
              </h4>
            </div>

            <Container className="py-5 cust-accordion">
              <Accordion activeKey={activeKey}>
                {faqs.map((item, index) => (
                  <Card
                    key={index}
                    className="faq-card bg-dark text-white mb-2"
                  >
                    <Accordion.Item
                      className="new-contact-us-item"
                      eventKey={index.toString()}
                    >
                      <Accordion.Header
                        onClick={() => toggleKey(index.toString())}
                        className="d-flex justify-content-between align-items-center"
                      >
                        <span>{item.question}</span>
                        <span className="toggle-icon">
                          {activeKey === index.toString() ? "×" : "+"}
                        </span>
                      </Accordion.Header>
                      <Accordion.Body>{item.answer}</Accordion.Body>
                    </Accordion.Item>
                  </Card>
                ))}
              </Accordion>
            </Container>
          </Container>
        </Container>

        {/* SECTION 7 */}

        <div className="new-home-section8 pt-5 mt-5">
          <Container>
            <h3 className="new-home-s8-outline">DOWNLOAD THE APP NOW</h3>
          </Container>
          <div className="new-home-colored-div">
            <img
              src="assets\images\newdesign\s8cut.png"
              style={{ height: "100%", zIndex: -1, opacity: 0.4 }}
              className="new-home-colored-img img-fluid"
              alt=""
            />
            <Container>
              <Row className="new-home-s8-download">
                <Col>
                  <div className="py-5">
                    <p className="new-home-s8-header mb-1">
                      Download the app now
                    </p>
                    <p className="new-home-s8-small">
                      appplication available on
                    </p>
                    <div className="d-flex gap-3 mb-2">
                      <div className="new-home-s8btn px-3 py-2">
                        {" "}
                        <img src="assets\images\newdesign\apple.svg" alt="" />
                      </div>
                      <div className="new-home-s8btn px-3 py-2">
                        {" "}
                        <img
                          src="assets\images\newdesign\playstore.svg"
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="d-flex align-items-center">
                      <img src="assets\images\newdesign\qr.png" alt="" />
                      <p className="mb-0">Scan QR code to join community</p>
                    </div>
                  </div>
                </Col>
                <Col>
                  <div className="w-100 d-flex justify-content-center">
                    <img
                      src="assets\images\newdesign\phone2.png"
                      className="img-fluid"
                      style={{ marginTop: "-20%" }}
                      alt=""
                    />
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
        {/* SECTION 8 */}

        <Footer />
      </div>
    </>
  );
};

export default NewContactUs;
